import { SeoHead } from "../components/common/SeoHead";
import { BlogList } from "../components/blog/BlogList";
import { Reveal } from "../components/common/Reveal";

export default function CreativeStories() {
  return (
    <main data-testid="creative-stories">
      <SeoHead
        title="Stories — Coffee With Dr. Irma · Stories | iINSPIRE Creative"
        description="Books, culture, ideas, reflections and creativity — essays and stories from iINSPIRE Creative."
        path="/creative/stories"
      />
      <section className="bg-warmwhite py-24 lg:py-32">
        <div className="container-site">
          <Reveal>
            <p className="eyebrow">Coffee With Dr. Irma · Stories</p>
            <h1 className="mt-4 max-w-3xl font-serif text-4xl leading-[1.08] tracking-tight text-ink sm:text-5xl">
              Stories worth <span className="italic text-amber">keeping.</span>
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink/75 sm:text-lg">
              Books · Culture · Ideas · Reflections · Creativity.
            </p>
          </Reveal>
          <BlogList vertical="publishing" channel="coffee-stories" basePath="/creative/stories" testId="stories-list" />
        </div>
      </section>
    </main>
  );
}
